/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Website_PlaceholderInputs */

const en_directory_submit_website_placeholder = /** @type {(inputs: Directory_Submit_Website_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://example.com`)
};

const zh_directory_submit_website_placeholder = /** @type {(inputs: Directory_Submit_Website_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://example.com`)
};

/**
* | output |
* | --- |
* | "https://example.com" |
*
* @param {Directory_Submit_Website_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_website_placeholder = /** @type {((inputs?: Directory_Submit_Website_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Website_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_website_placeholder(inputs)
	return zh_directory_submit_website_placeholder(inputs)
});
export { directory_submit_website_placeholder as "directory.submit.website_placeholder" }